// @flow
import React, { Component } from 'react';
import Toggle from 'react-toggle';
import './TokenGenerator.scss';

type Props = {
  deleteToken: Function,
  jwtTokenID: String,
  tokenDeleteRequest: Function,
  tokenActivateRequest: Function,
  tokenDeactivateRequest: Function,
  active: number,
  toggleStatus: Function,
  expiry: string,
}

export default class TokenGenerator extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      active: this.convertActive(this.props.active),
    };
  }

  componentWillUpdate(nextProps: Props) {
    const changeStatus: boolean = nextProps.active !== this.props.active;

    if (changeStatus) {
      this.setState({
        active: this.convertActive(nextProps.active),
      });
    }
  }

  convertActive = (activeStatus: number) => activeStatus === 1;

  handleToggleChange = () => {
    const currentStatus = !this.state.active;
    const jwt = this.props.jwtTokenID;
    if (currentStatus) {
      this.props.tokenActivateRequest(jwt);
    } else {
      this.props.tokenDeactivateRequest(jwt);
    }
  };

  render() {
    return (
      <div className="tokenComponent">
        <div className="card columns">
          <div className="content-wrapper column is-three-quarters">
            <div className="card-contents">
              <p>Token Id: {this.props.jwtTokenID}</p>
            </div>
            <footer className="card-footer">
              <div className="column ">
                <div className="card-footer-item tokenFooter">
                  <div className="tokenStatus">Status: {this.state.active ? 'Activated' : 'Deactivated'}</div>
                  <Toggle
                    checked={this.state.active}
                    icons={false}
                    onChange={this.handleToggleChange}
                  />
                </div>
                <p className="card-footer-item tokenFooter">
                  Expiry Date: {this.props.expiry}
                </p>
              </div>
            </footer>
          </div>
          <div className="column is-one-quarter">
            <button
              className="button is-danger tokenDelBtn"
              title="Delete token"
              aria-label="Delete token"
              type="button"
              onClick={() => {
                /* eslint-disable no-alert */
                if (confirm(`Are you sure you want to delete Token ${this.props.jwtTokenID}?`)) {
                  this.props.tokenDeleteRequest(this.props.jwtTokenID);
                }
              }}
            >
              <span className="icon" aria-hidden="true">
                <i className="fa fa-trash" />
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/token_management/TokenGenerator.js
 **/